import { Suspense, type ReactNode } from 'react';
import { Navigate, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useCan } from '../../auth';
import { movedTo, type Tab } from '../../nav';
import { Loading } from '../../ui/kit';
import './sections.css';

/** Tab strip for a nav section with several pages. Tabs the role may not view are left out. */
export function SectionTabs({ tabs, label }: { tabs: Tab[]; label: string }) {
  const can = useCan();
  const shown = tabs.filter((t) => !t.perm || can(t.perm));
  if (shown.length < 2) return null;
  return (
    <nav className="section-tabs" aria-label={label}>
      {shown.map((t) => <NavLink key={t.to} to={t.to} end={t.end}>{t.label}</NavLink>)}
    </nav>
  );
}

/** Layout route: the section's tabs above the current tab's page. */
export function TabsLayout({ tabs, label, top }: { tabs: Tab[]; label: string; top?: ReactNode }) {
  return (
    <>
      <SectionTabs tabs={tabs} label={label} />
      {top}
      <Suspense fallback={<Loading />}><Outlet /></Suspense>
    </>
  );
}

/** Redirect from an earlier URL, keeping the rest of the path, the query string and the hash. */
export function Moved({ from, to }: { from: string; to: string }) {
  const loc = useLocation();
  return <Navigate replace to={movedTo(from, to, loc.pathname, loc.search, loc.hash)} />;
}
